import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import { TruckName } from './TransportNameStyles';

const actionNames = {
  rent: 'Арендую',
  purchase: 'Куплю',
};

const TransportName = observer(() => {
  const {
    advertsStore: { currentAdvert, getTruckName },
  } = useStores();

  const actionName = currentAdvert.proposal_type;
  const actionNameStr = actionName && actionNames[actionName] && `${actionNames[actionName]} `;

  return (
    <TruckName status={currentAdvert.status}>
      {actionNameStr}
      {getTruckName()}
    </TruckName>
  );
});

export default TransportName;
